var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.501,
    height: 20.498,
    viewBox: "0 0 20.501 20.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-mail-2499289",
    transform: "translate(-85.749 -15.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_30",
    "data-name": "Union 30",
    d: "M-3787.051-9228.5h-19.4a.543.543,0,0,1-.408-.184.547.547,0,0,1-.139-.354c0-.006,0-.013,0-.019v-13.053a.555.555,0,0,1,.552-.557.553.553,0,0,1,.081.006l2.038-1.332v-2.606a.551.551,0,0,1,.557-.545h4.068l2.649-1.765a.555.555,0,0,1,.606,0l2.652,1.765h4.068a.549.549,0,0,1,.555.545v2.6l2.04,1.334a.528.528,0,0,1,.079-.006.555.555,0,0,1,.555.557v13.053a.555.555,0,0,1-.02.147.545.545,0,0,1-.119.224.545.545,0,0,1-.408.186Zm-1.458-1.114-6.963-6.184-.974.636a.541.541,0,0,1-.3.091.542.542,0,0,1-.3-.091l-.975-.637-6.964,6.185Zm.9-.661v-10.66l-6.916,4.518Zm-18.289,0,6.917-6.144-6.917-4.518Zm9.146-6,6.467-4.224v-3.008a.54.54,0,0,1-.039-.122.529.529,0,0,1,.039-.336v-2.088h-12.934v2.092a.544.544,0,0,1,.039.332.568.568,0,0,1-.039.119v3.012Zm7.576-4.948,1.116-.729-1.116-.729Zm-16.272-.729,1.117.729v-1.458Zm9.675-5.192-.979-.652-.98.652Z",
    transform: "translate(3892.75 9264.752)",
    fill: "#3b4452"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.bafe820641fe25820608bb34d51cf3d3.svg";
export { ForwardRef as ReactComponent };